import { useParams } from 'react-router'

import { Loading } from '@/components/Loading'
import { useSubscriptionGuard } from '@/hooks/useSubscriptionGuard'

type RedirectTo =
  | string
  | ((params: Record<string, string | undefined>) => string)

export const SubscriptionGuardedPage = ({
  redirectTo,
  children,
}: {
  redirectTo: RedirectTo
  children: React.ReactNode
}) => {
  const params = useParams()
  const destination =
    typeof redirectTo === 'function' ? redirectTo(params) : redirectTo
  const { isAllowed, isLoading } = useSubscriptionGuard(destination)

  if (isLoading || !isAllowed) {
    return <Loading />
  }

  return children
}
